export default "__VITE_ASSET__98663971__"